<template>
    <div class="b1t-okraina-catalog-section">
        <div v-if="!section.stub">

            <div v-if="section.SECTIONS_CNT > 0">
                <b1t-okraina-catalog-sections v-bind:parent="this.section.ID"/>
            </div>

        </div>
        
    </div>
</template>

<script>
    import axios from 'axios';
    import objectToFormData from '../../../plugins/object-to-form-data'

    import b1tOkrainaCatalogSections from '../catalog/sections'

    export default {
        name: 'b1t-okraina-catalog-section',
        components: {
            b1tOkrainaCatalogSections
        },
        data() {
            return {
                section: {
                    stub: true
                },
            }
        },
        methods: {
            load() {
                return axios(this.$store.state.apiUrl + '/rest/catalog.sections.getbyid', {
                    method: "POST",
                    data: objectToFormData({
                        "ID": this.$route.params.id
                    }),
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
                    }
                }).then((response) => {

                    this.section = response.data;
                    
                    return response;
                }).catch((error) => {
                    return error;
                })
            },

        },
        mounted(){
            this.load();
        },
        watch: {
            $route(to) {
                if(to.name === "catalog-section") {
                    if(this.section.ID !== this.$route.params.id) {
                         this.load();
                    }
                }
            }
        }
    }
</script>

<style lang="scss">

</style>